import React from "react";

const UserContext = React.createContext({
  user: {},
  setUser: () => {},
  userRole: "",
  setUserRole: () => "",
});

export default UserContext;
